import React from 'react';
import styled, { withTheme } from 'styled-components';
import { MaxWidthLayoutDesktop } from '../../../templates/MaxWidthLayout';
import FullLayout from '../../../templates/FullLayout';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import GlobalNavigationSlot from './GlobalNavigationSlot';
import ProfileBalance from './ProfileBalance';

const GlobalNav = styled.nav`
  ${(p) => p.theme.typographyRebrand.body.sm}
  background-color: ${(p) => p.theme.c.bg.secondary};
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  &.right {
    @media screen and (max-width: 1140px) {
      justify-content: flex-end;
    }
  }
`;

const GlobalNavUl = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  padding-left: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  height: 100%;
  &.left {
    @media screen and (max-width: 1140px) {
      display: none;
    }
  }
`;

const GlobalNavProfileTools = styled.div`
  display: flex; 
  align-items: center;
`;

const GlobalNavigation = withTheme((props) => {
  const {
    theme,
    siteNavSlots = [],
    anonNavSlots = [],
    balanceNavSlots = [],
    navSlots = [],
    locale,
    localeUrls,
    subCategoryLocaleSlugMap,
    currentPath,
    pageStateModifiers,
    visitInfo = {},
    globalPageConfig = {},
  } = props;

  const cssSearchBarDesktopBgColor = `background-color: ${theme.c.bg.secondary};`;

  const leftNavSlots = siteNavSlots;

  const rightNavSlots = pageStateModifiers.isUserLoggedIn() ? navSlots : anonNavSlots;

  const profileBalance = balanceNavSlots;

  const DesktopBody = () => (
    <FullLayout outerStyles={cssSearchBarDesktopBgColor}>
      <MaxWidthLayoutDesktop>
        <GlobalNav aria-label="Global" className="right">
          <GlobalNavUl className="left">
            {leftNavSlots.map((slot, index) => {
              return (
                <GlobalNavigationSlot
                  currentPath={currentPath}
                  key={`${slot.text}-${index}`}
                  {...slot}
                  locale={locale}
                  localeUrls={localeUrls}
                  subCategoryLocaleSlugMap={subCategoryLocaleSlugMap}
                  leftSlot
                />
              );
            })}
          </GlobalNavUl>
          <GlobalNavProfileTools>
             {
                // TODO : To cleanly handle one balance feature flag we should create a new component called:
                // ProfileOneBalance that handles the display of name and balance and conditionally render that
                // component or the old one depending on the feature flag.
              }
            {pageStateModifiers.isUserLoggedIn() && (
              <ProfileBalance
                visitInfo={visitInfo}
                profileBalanceNavSlot={profileBalance}
                globalPageConfig={globalPageConfig}
              />
            )}
            <GlobalNavUl>
              {rightNavSlots.map((slot, index) => {
                return (
                  <GlobalNavigationSlot
                    currentPath={currentPath}
                    key={`${slot.text}-${index}`}
                    {...slot}
                    locale={locale}
                    localeUrls={localeUrls}
                    subCategoryLocaleSlugMap={subCategoryLocaleSlugMap}
                    pageStateModifiers={pageStateModifiers} />
                );
              })}
            </GlobalNavUl>
          </GlobalNavProfileTools>
        </GlobalNav>
      </MaxWidthLayoutDesktop>
    </FullLayout>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody()}
      mobileChildren={null}
     />
  );
  return renderComp;
});

export default GlobalNavigation;
